import { useEffect, useRef, useState } from 'react';
import { useSocket } from '../socket/useSocket';
import { useInterval } from './useInterval';
import { useGetParams } from './useGetParams';
import { useFetchVote } from './useFetchVote';
import { useVotes } from '../context/VotesContext';

export const useController = (authorId) => {
  const { votes, setVote } = useVotes();

  const { wsActive } = useGetParams();

  // Голосование\Викторина
  const [voteState, setVoteState] = useState(null);
  // // id текущего запущенного голосования\викторины
  const voteActiveIdRef = useRef('');
  const [currentState, setCurrentState] = useState(null);
  const [isVisible, setIsVisible] = useState(null);
  const [isActive, setIsActive] = useState(null);

  const refs = { voteActiveIdRef };
  const setters = {
    setIsVisible,
    setCurrentState,
    setVoteState,
    setIsActive,
    setVote,
  };

  const { getVoteInfo } = useFetchVote({
    refs,
    setters,
    voteState,
    authorId,
  });

  const optionalParams = { getVoteInfo };

  const { webSocket, startSocket, isRegularFetch } = useSocket({
    refs,
    setters,
    optionalParams,
  });

  useEffect(() => {
    getVoteInfo();
  }, []);

  useEffect(() => {
    if (Boolean(wsActive)) {
      startSocket();
      return () => {
        webSocket?.close();
      };
    }
  }, [wsActive]);

  // работа через обычные запросы
  useInterval(getVoteInfo, !Boolean(wsActive) || isRegularFetch ? 1000 : null);

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        getVoteInfo();
      }
    };
    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () =>
      document.removeEventListener('visibilitychange', handleVisibilityChange);
  }, []);

  return {
    currentState,
    isVisible,
    voteState,
    idVote: voteActiveIdRef.current,
    isActive,
  };
};
